import { handleAxiosError } from 'core/notifications';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import axios from '@/util/axios';

import getAxiosConfig from '../helpers/getAxiosConfig';

export default ({ id, type }) => {
  const queryClient = useQueryClient();

  const dashboards = useQuery({
    onError: handleAxiosError,
    queryFn: async () => (await axios(getAxiosConfig('get-dashboards', { id, type }))).data,
    queryKey: ['dashboards', type, id],
  });

  const updatePinned = useMutation({
    mutationFn: (params) => axios(getAxiosConfig('toggle-dashboard-pin', params)),
    onSuccess: (_, dashboard) => {
      dashboards.refetch();

      queryClient.setQueriesData({ queryKey: ['dashboard', dashboard.id] }, (data) => ({
        ...data,
        is_favorited: !dashboard.is_favorited,
      }));
    },
    onError: handleAxiosError,
  });

  return { dashboards, updatePinned };
};
